export const getMenuData = [
  {
    category: true,
    title: 'Dashboard',
  },
  {
    title: 'Dashboard',
    key: 'dashboard',
    icon: 'fe fe-home',
    // roles: ['admin'], // set user roles with access to this route
    url: '/dashboard',
  },
  {
    title: 'Catalogue',
    key: 'catalogue',
    icon: 'fe fe-shopping-bag',
    children: [
      {
        title: 'Product List',
        key: 'catalogue/product-list',
        url: '/catalogue/products',
      },
      // {
      //   title: 'Selected Products',
      //   key: 'catalogue/selected-products',
      //   url: '/catalogue/selected-products',
      // },
      // {
      //   title: 'Product Categories',
      //   key: 'catalogue/categories',
      //   url: '/catalogue/category',
      // },
      // {
      //   title: 'Stock Adjustment',
      //   key: 'catalogue/stock',
      //   url: '/catalogue/stock-adjustment',
      // },
    ],
  },
  {
    title: 'Sales Orders',
    key: 'sales-orders',
    icon: 'fe fe-shopping-cart',
    url: '/orders',
  },
  {
    title: 'Promotion',
    key: 'discounts',
    url: '/discounts',
    icon: 'fe fe-tag',
  },
  {
    title: 'Resellers',
    key: 'resellers',
    url: '/resellers',
    icon: 'fe fe-share-2',
  },

  // {
  //   title: 'Users',
  //   key: 'users',
  //   url: '/users',
  //   icon: 'fe fe-user-check',
  // },

  {
    title: 'Settings',
    key: 'settings',
    icon: 'fe fe-settings',
    children: [
      {
        title: 'Store setting',
        url: '/settings/store',
        key: '/settings/store',
      },
      // {
      //   title: 'Payments',
      //   url: '/settings/payments',
      //   key: '/settings/payments',
      // },
      // {
      //   title: 'Warehouse',
      //   url: '/settings/warehouse',
      //   key: '/settings/warehouse',
      // },
    ],
  },
]
